import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  FaCommentDots, FaTimes, FaPaperPlane, FaRobot, FaUser,
  FaPhone, FaEnvelope, FaArrowLeft, FaHome, FaWhatsapp,
  FaChevronRight, FaSearch,
} from 'react-icons/fa';
import './ChatBot.css';

const GOOGLE_SHEETS_CONTACT_URL = 'https://script.google.com/macros/s/AKfycbz8V5hlvIIf7c94SruBMRJK_sQ4IuoecdZ_7HRU8SJ6c0MBvZxtVTQul2dCRIPMlQNaxQ/exec';


// ── Menu Categories ─────────────────────────────────────────────
const MENU = [
  { id: 'tally',     img: '/images/Primelogo.webp',                                                      label: 'TallyPrime & ERP',    desc: 'Accounting, GST, Payroll'  },
  { id: 'web',       img: '/images/webapp.png',                                                          label: 'Web Development',      desc: 'Websites & Web Apps'       },
  { id: 'mobile',    img: '/images/mobile-app.webp',                                                     label: 'Mobile Apps',          desc: 'Android & iOS'             },
  { id: 'hardware',  img: '/hardware/hardware.png',                                                      label: 'Hardware Solutions',   desc: 'Laptops, Printers, AMC'    },
  { id: 'cctv',      img: '/images/shopping.webp',                                                       label: 'CCTV & Security',      desc: 'Surveillance Systems'      },
  { id: 'bio',       img: '/images/biometric-time-attendance-500x500.webp',                              label: 'Biometrics',           desc: 'Attendance & Access'       },
  { id: 'server',    img: '/images/SERVER.png',                                                          label: 'Server & Network',     desc: 'Infrastructure Setup'      },
  { id: 'antivirus', img: '/images/WhatsApp_Image_2024-10-21_at_4.47.15_PM-removebg-preview.png',       label: 'Antivirus',            desc: 'Endpoint Security'         },
  { id: 'backup',    img: '/images/cloud.png',                                                           label: 'Auto Backup',          desc: 'Data Protection'           },
  { id: 'contact',   img: '/images/cont.png',                                                            label: 'Contact Us',           desc: 'Reach our team'            },
  { id: 'about',     img: '/images/imatrix.jpg',                                                         label: 'About iMatrix',        desc: 'Our story & milestones'    },
];

// ── Knowledge Base ───────────────────────────────────────────────
const KB = {
  tally: {
    text: "📊 **TallyPrime Solutions**\n\nAs a **Tally 5-Star Partner since 2006**, we offer:\n\n• **TallyPrime Gold** — Multi-user, full features\n• **TallyPrime Silver** — Single-user edition\n• **Tally on Cloud (AWS)** — Access from anywhere\n• **TDL Customization** — Tailor Tally to your needs\n• **GST Filing & Compliance** — Hassle-free returns\n• **Payroll & Inventory** — End-to-end management\n\n📞 TDL: +91 98415 94294\n📧 tdl@imatrixtechnologies.com",
    action: { label: 'Explore TallyPrime', route: '/tallyprime' },
  },
  web: {
    text: "💻 **Web Development**\n\nEnterprise-grade digital experiences:\n\n• **Custom Websites** — Corporate & e-commerce\n• **Web Applications** — CRM, ERP, portals\n• **React / Node.js** — Modern tech stack\n• **UI/UX Design** — Stunning interfaces\n• **API Integration** — Connect your systems\n\n📞 Dev: +91 95006 25633\n📧 development@imatrixtechnologies.com",
    action: { label: 'Web Services', route: '/WebDevelopment' },
  },
  mobile: {
    text: "📱 **Mobile App Development**\n\nHigh-performance mobile experiences:\n\n• **Android & iOS** — Native & cross-platform\n• **Flutter** — Beautiful, fast apps\n• **Business Apps** — Attendance, delivery, field force\n• **ERP Integration** — Tally & cloud sync\n\n📞 +91 95006 25633",
    action: { label: 'Mobile Services', route: '/MobileDeveloper' },
  },
  hardware: {
    text: "🖥️ **Hardware Solutions**\n\nComplete IT hardware procurement:\n\n• **Laptops & Desktops** — All major brands\n• **Printers & Scanners** — Sales, AMC & support\n• **Networking Equipment** — Switches, routers\n• **Workstation Setup** — Full office IT setup\n• **AMC Contracts** — Annual maintenance\n\n📞 Hardware: +91 98415 45557\n📧 hardware@imatrixtechnologies.com",
    action: { label: 'Hardware Services', route: '/HardwareServices' },
  },
  cctv: {
    text: "📷 **CCTV & Security Systems**\n\nSmart surveillance for your premises:\n\n• **IP & HD Cameras** — Indoor & outdoor\n• **NVR/DVR Systems** — Centralized recording\n• **Night Vision** — 24/7 monitoring\n• **Remote Access** — View from anywhere\n• **Free Site Survey** — Assessment available\n\n📞 +91 98416 09990",
    action: { label: 'CCTV & Security', route: '/SecuritySystem' },
  },
  bio: {
    text: "🔐 **Biometric Solutions**\n\nModern workforce & access management:\n\n• **Fingerprint Devices** — Standalone & networked\n• **Face Recognition** — Touchless attendance\n• **Access Control** — Door locks & barriers\n• **Payroll Integration** — Auto attendance sync\n• **Multi-location** — Centralized management\n\n📞 +91 98416 09990",
    action: { label: 'Biometric Systems', route: '/BIO' },
  },
  server: {
    text: "🗄️ **Server & Network Solutions**\n\nEnterprise-grade IT infrastructure:\n\n• **Server Setup** — HP, Dell, Lenovo\n• **NAS Storage** — Centralized data storage\n• **Network Design** — LAN, WAN, VPN\n• **Remote Monitoring** — 24/7 uptime\n\n📞 +91 98416 09990",
    action: { label: 'Server Solutions', route: '/ServerPage' },
  },
  antivirus: {
    text: "🛡️ **Antivirus & Endpoint Security**\n\nEnterprise protection:\n\n• **Kaspersky, Quick Heal, Seqrite** — Top brands\n• **Endpoint Protection** — All devices covered\n• **Centralized Management** — Admin console\n• **Email & Web Security** — Threat filtering\n• **Ransomware Protection** — Advanced defense\n\n📞 +91 98416 09990",
    action: { label: 'Antivirus', route: '/Antivirus' },
  },
  backup: {
    text: "☁️ **Auto Backup Software**\n\nNever lose critical business data:\n\n• **Automated Scheduling** — Daily, weekly, monthly\n• **Cloud & Local Backup** — Dual redundancy\n• **Tally Data Backup** — Specialized for ERP\n• **Instant Recovery** — Restore in minutes\n• **Encryption** — AES-256 protection\n\n📞 +91 98416 09990",
    action: { label: 'Backup Software', route: '/autoBackupSoftware' },
  },
  pricing: {
    text: "💰 **Pricing & Quotations**\n\nCustomized based on your needs:\n\n• Number of users / licenses\n• Module requirements\n• Implementation & training\n• Support contract duration\n\n📌 **TallyPrime** starts from ₹18,000/year\n📌 **Custom software** quoted per project scope\n\nFor a **free consultation & quote**:\n📞 +91 98416 09963",
    action: { label: 'View Plans', route: '/PlansAndPricing' },
  },
  contact: {
    text: "📞 **Contact iMatrix Technologies**\n\n🏢 #R-76 MMDA Colony, Arumbakkam,\nChennai – 600 106\n📱 HQ: +91 98410 33443\n\n📱 TDL: +91 98415 94294\n📱 Software: +91 95006 25633\n📱 Hardware: +91 98415 45557\n📱 Support: +91 98416 09990\n📱 Marketing: +91 98416 09963\n\n✉️ admin@imatrixtechnologies.com\n⏰ Mon–Sat: 9 AM – 6 PM IST",
    action: { label: 'Contact Page', route: '/contact' },
  },
  about: {
    text: "🏢 **About iMatrix Technologies**\n\nFounded in **2006**, Chennai's leading IT solutions company.\n\n✅ **Tally 5-Star Partner** — Highest certification\n✅ **20+ Years** of industry expertise\n✅ **3000+ Happy Clients** across South India\n✅ **ISO Certified** — Quality assured\n✅ **10+ Premium Services** — Single-window IT\n\nFrom accounting software to full IT infrastructure!",
    action: { label: 'About iMatrix', route: '/AboutPage' },
  },
};

// ── Keyword → menu id mapping ─────────────────────────────────────
const KEYWORD_MAP = [
  { keys: ['tally','erp','gst','accounting','payroll','inventory','tdl'], id: 'tally' },
  { keys: ['web','website','portal','react','node'], id: 'web' },
  { keys: ['mobile','android','ios','flutter','app'], id: 'mobile' },
  { keys: ['hardware','laptop','printer','computer','desktop','amc'], id: 'hardware' },
  { keys: ['cctv','camera','security','surveillance','nvr','dvr'], id: 'cctv' },
  { keys: ['biometric','fingerprint','attendance','face','access'], id: 'bio' },
  { keys: ['server','network','nas','infrastructure'], id: 'server' },
  { keys: ['antivirus','virus','malware','ransomware','endpoint'], id: 'antivirus' },
  { keys: ['backup','cloud','recovery'], id: 'backup' },
  { keys: ['price','pricing','cost','quote','plan','budget'], id: 'pricing' },
  { keys: ['contact','call','phone','email','reach','enquiry'], id: 'contact' },
  { keys: ['about','company','imatrix','founded','history'], id: 'about' },
];

function detectIntent(text) {
  const lower = text.toLowerCase();
  for (const { keys, id } of KEYWORD_MAP) {
    if (keys.some(k => lower.includes(k))) return id;
  }
  return null;
}

function renderMd(text) {
  return text
    .split('\n')
    .map((line) => line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>'))
    .join('<br/>');
}

// ── VIEW MODES ────────────────────────────────────────────────────
// 'home'  → welcome + menu grid
// 'chat'  → free-text conversation (with back-to-menu btn)

const WELCOME = "👋 Hi! I'm **iMatrix Assistant**.\n\nChoose a topic below or type your question — I'll find the right answer for you!";

const ChatBot = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen]       = useState(false);
  const [view, setView]       = useState(() => {
    const submitted = localStorage.getItem('imatrix_chat_lead_submitted') === 'true';
    return submitted ? 'home' : 'lead';
  });
  const [input, setInput]     = useState('');
  const [messages, setMessages] = useState([]);
  const [typing, setTyping]   = useState(false);
  const [search, setSearch]   = useState('');
  const [unread, setUnread]   = useState(0);

  // Lead capture states
  const [leadSubmitted, setLeadSubmitted] = useState(() => {
    return localStorage.getItem('imatrix_chat_lead_submitted') === 'true';
  });
  const [leadName, setLeadName] = useState('');
  const [leadContact, setLeadContact] = useState('');
  const [isSubmittingLead, setIsSubmittingLead] = useState(false);
  const [leadError, setLeadError] = useState('');

  const bodyRef  = useRef(null);
  const inputRef = useRef(null);
  const searchRef = useRef(null);
  const leadNameRef = useRef(null);

  // Auto-scroll chat body
  useEffect(() => {
    if (bodyRef.current) bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
  }, [messages, typing]);

  // Focus input when switching to views
  useEffect(() => {
    if (view === 'chat') setTimeout(() => inputRef.current?.focus(), 200);
    if (view === 'home') setTimeout(() => searchRef.current?.focus(), 200);
    if (view === 'lead') setTimeout(() => leadNameRef.current?.focus(), 200);
  }, [view]);

  // Unread badge when closed
  useEffect(() => {
    if (!open && messages.length > 0) setUnread(u => u + 1);
    if (open) setUnread(0);
  }, [messages.length, open]);

  const handleToggleOpen = () => {
    setOpen(prev => {
      const nextOpen = !prev;
      if (nextOpen) {
        const submitted = localStorage.getItem('imatrix_chat_lead_submitted') === 'true';
        if (!submitted) {
          setView('lead');
        } else if (view === 'lead') {
          setView('home');
        }
      }
      return nextOpen;
    });
  };

  const handleLeadSubmit = (e) => {
    e.preventDefault();
    const name = leadName.trim();
    const contact = leadContact.trim();
    if (!name || !contact) {
      setLeadError('Please fill in both fields.');
      return;
    }
    if (contact.length < 8) {
      setLeadError('Please enter a valid contact number.');
      return;
    }
    setLeadError('');
    setIsSubmittingLead(true);

    fetch(GOOGLE_SHEETS_CONTACT_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        firstName: name,
        lastName: '(ChatBot Lead)',
        companyName: 'ChatBot Assistant',
        mobileNumber: contact,
        email: '',
        product: 'ChatBot Lead Form',
        message: 'Lead details captured before starting chat assistant.',
      }),
    })
      .then(() => {
        setIsSubmittingLead(false);
        setLeadSubmitted(true);
        localStorage.setItem('imatrix_chat_lead_submitted', 'true');
        setView('home');
      })
      .catch((error) => {
        console.error('Error submitting chatbot lead:', error);
        setIsSubmittingLead(false);
        // Fallback to letting the user continue even if spreadsheet fetch fails
        setLeadSubmitted(true);
        localStorage.setItem('imatrix_chat_lead_submitted', 'true');
        setView('home');
      });
  };


  const pushBot = (id) => {
    const resp = KB[id];
    if (!resp) return;
    setView('chat');
    setTyping(true);
    setTimeout(() => {
      setTyping(false);
      setMessages(prev => [...prev,
        { type: 'bot', text: resp.text, action: resp.action || null }
      ]);
    }, 700);
  };

  const handleMenuClick = (id) => {
    setView('chat');
    const item = MENU.find(m => m.id === id);
    setMessages(prev => [...prev,
      { type: 'user', text: item.label, img: item.img },
    ]);
    pushBot(id);
  };

  const handleSend = (e) => {
    e?.preventDefault();
    const text = input.trim();
    if (!text) return;
    setInput('');
    setView('chat');
    setMessages(prev => [...prev, { type: 'user', text }]);
    setTyping(true);
    setTimeout(() => {
      const id = detectIntent(text);
      setTyping(false);
      if (id) {
        setMessages(prev => [...prev, { type: 'bot', text: KB[id].text, action: KB[id].action || null }]);
      } else {
        setMessages(prev => [...prev, {
          type: 'bot',
          text: "I'm not sure about that, but our team is happy to help! 😊\n\n📞 **+91 98416 09990**\n📧 **admin@imatrixtechnologies.com**\n\nOr press **↩ Back to Menu** to explore our services.",
          action: { label: 'Contact Page', route: '/contact' },
        }]);
      }
    }, 800 + Math.random() * 400);
  };

  const goHome = () => { setView('home'); setSearch(''); };

  const filteredMenu = search.trim()
    ? MENU.filter(m => m.label.toLowerCase().includes(search.toLowerCase()) || m.desc.toLowerCase().includes(search.toLowerCase()))
    : MENU;

  // Hide chatbot on admin/whatsnew page
  if (location.pathname.startsWith('/admin/whatsnew')) {
    return null;
  }

  return (
    <div className={`cb-wrapper ${open ? 'cb-wrapper--open' : ''}`} aria-live="polite">
      {open && (
        <div className="cb-panel" role="dialog" aria-label="iMatrix Chat Assistant">

          {/* ── Header ── */}
          <div className="cb-header">
            {view === 'chat' && (
              <button className="cb-header__back" onClick={goHome} aria-label="Back to menu" title="Back to menu">
                <FaArrowLeft />
              </button>
            )}
            <div className="cb-header__avatar">
              <FaRobot />
              <span className="cb-header__online" />
            </div>
            <div className="cb-header__info">
              <p className="cb-header__name">iMatrix Assistant</p>
              <p className="cb-header__status">
                {view === 'lead' ? 'Online · Getting Started' : view === 'chat' ? 'Online · Ask me anything' : 'Online · Browse or type a question'}
              </p>
            </div>
            <div className="cb-header__actions">
              {view === 'chat' && (
                <button className="cb-header__icon-btn" onClick={goHome} title="Main Menu">
                  <FaHome />
                </button>
              )}
              <button className="cb-header__close" onClick={() => setOpen(false)} aria-label="Close chat">
                <FaTimes />
              </button>
            </div>
          </div>

          {/* ── LEAD VIEW ── */}
          {view === 'lead' && (
            <div className="cb-lead">
              <div className="cb-lead__welcome">
                <h3 className="cb-lead__title">Welcome! 👋</h3>
                <p className="cb-lead__subtitle">Please enter your name and contact details to connect with the iMatrix Assistant.</p>
              </div>
              <form onSubmit={handleLeadSubmit} className="cb-lead__form">
                <div className="cb-lead__group">
                  <label htmlFor="lead-name" className="cb-lead__label">Full Name</label>
                  <div className="cb-lead__input-wrapper">
                    <FaUser className="cb-lead__input-icon" />
                    <input
                      ref={leadNameRef}
                      id="lead-name"
                      type="text"
                      placeholder="Enter your name"
                      value={leadName}
                      onChange={e => setLeadName(e.target.value)}
                      required
                      disabled={isSubmittingLead}
                    />
                  </div>
                </div>

                <div className="cb-lead__group">
                  <label htmlFor="lead-contact" className="cb-lead__label">Contact Number</label>
                  <div className="cb-lead__input-wrapper">
                    <FaPhone className="cb-lead__input-icon" />
                    <input
                      id="lead-contact"
                      type="tel"
                      placeholder="Enter your contact number"
                      value={leadContact}
                      onChange={e => setLeadContact(e.target.value)}
                      required
                      disabled={isSubmittingLead}
                    />
                  </div>
                </div>

                {leadError && <p className="cb-lead__error">{leadError}</p>}

                <button type="submit" className="cb-lead__btn" disabled={isSubmittingLead}>
                  {isSubmittingLead ? 'Starting...' : 'Start Chatting'}
                </button>
              </form>
            </div>
          )}

          {/* ── HOME VIEW ── */}
          {view === 'home' && (
            <div className="cb-home">
              <div className="cb-home__welcome">
                <p dangerouslySetInnerHTML={{ __html: renderMd(WELCOME) }} />
              </div>

              {/* Search */}
              <div className="cb-search">
                <FaSearch className="cb-search__icon" />
                <input
                  ref={searchRef}
                  type="text"
                  placeholder="Search a topic…"
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                  onKeyDown={e => { if (e.key === 'Enter' && search.trim()) { setInput(search); setSearch(''); handleSend(); } }}
                />
                {search && <button className="cb-search__clear" onClick={() => setSearch('')}><FaTimes /></button>}
              </div>

              {/* Menu Grid */}
              <div className="cb-menu">
                {filteredMenu.length === 0 && (
                  <p className="cb-menu__empty">No results. Try a different keyword.</p>
                )}
                {filteredMenu.map(item => (
                  <button key={item.id} className="cb-menu__item" onClick={() => handleMenuClick(item.id)}>
                    <span className="cb-menu__icon">
                      <img src={item.img} alt={item.label} className="cb-menu__img" />
                    </span>
                    <div className="cb-menu__text">
                      <span className="cb-menu__label">{item.label}</span>
                      <span className="cb-menu__desc">{item.desc}</span>
                    </div>
                    <FaChevronRight className="cb-menu__arrow" />
                  </button>
                ))}
              </div>

              {/* Quick contact strip */}
              <div className="cb-home__strip">
                <a href="tel:+919841609990" className="cb-strip__btn cb-strip__btn--call">
                  <FaPhone /> Call Now
                </a>
                <a href="https://wa.me/919841609990" target="_blank" rel="noopener noreferrer" className="cb-strip__btn cb-strip__btn--wa">
                  <FaWhatsapp /> WhatsApp
                </a>
                <a href="mailto:admin@imatrixtechnologies.com" className="cb-strip__btn cb-strip__btn--mail">
                  <FaEnvelope /> Email
                </a>
              </div>
            </div>
          )}

          {/* ── CHAT VIEW ── */}
          {view === 'chat' && (
            <>
              <div className="cb-body" ref={bodyRef}>
                {/* Back-to-menu chip at top */}
                <div className="cb-back-chip-wrap">
                  <button className="cb-back-chip" onClick={goHome}>
                    <FaArrowLeft /> Back to Menu
                  </button>
                </div>

                {messages.map((msg, i) => (
                  <div key={i} className={`cb-msg cb-msg--${msg.type}`}>
                    {msg.type === 'bot' && <span className="cb-msg__avatar"><FaRobot /></span>}
                    <div className="cb-msg__bubble">
                      {msg.type === 'user' && msg.img && (
                        <img src={msg.img} alt={msg.text} className="cb-msg__thumb" />
                      )}
                      <p className="cb-msg__text" dangerouslySetInnerHTML={{ __html: renderMd(msg.text) }} />
                      <div className="cb-msg__btns">
                        {msg.action && (
                          <button className="cb-msg__action-btn" onClick={() => { navigate(msg.action.route); setOpen(false); }}>
                            {msg.action.label} →
                          </button>
                        )}
                        {msg.type === 'bot' && (
                          <button className="cb-msg__menu-btn" onClick={goHome}>
                            <FaHome /> Main Menu
                          </button>
                        )}
                      </div>
                    </div>
                    {msg.type === 'user' && <span className="cb-msg__avatar cb-msg__avatar--user"><FaUser /></span>}
                  </div>
                ))}

                {typing && (
                  <div className="cb-msg cb-msg--bot">
                    <span className="cb-msg__avatar"><FaRobot /></span>
                    <div className="cb-msg__bubble cb-typing"><span /><span /><span /></div>
                  </div>
                )}
              </div>

              <form className="cb-input" onSubmit={handleSend}>
                <input
                  ref={inputRef}
                  type="text"
                  placeholder="Ask a follow-up question…"
                  value={input}
                  onChange={e => setInput(e.target.value)}
                  aria-label="Chat input"
                />
                <button type="submit" aria-label="Send" disabled={!input.trim()}>
                  <FaPaperPlane />
                </button>
              </form>
            </>
          )}

        </div>
      )}

      {/* ── FAB ── */}
      <button
        className={`cb-fab ${open ? 'cb-fab--open' : ''}`}
        onClick={handleToggleOpen}
        aria-label="Toggle chat assistant"
        id="chatbot-toggle-btn"
      >
        {open ? <FaTimes size={22} /> : <FaCommentDots size={22} />}
        {!open && <span className="cb-fab__pulse" />}
        {!open && unread > 0 && <span className="cb-fab__badge">{unread}</span>}
      </button>
    </div>
  );
};

export default ChatBot;
